import { proCheckoutStartedEvent } from '#pplx/frontend/apps/ask/events/billing/analytics.js';
import { openWebSubscriptionPage, shouldOpenSubscriptionOnWeb, } from '#pplx/frontend/apps/ask/hooks/subscription-hooks/webSubscriptionRedirect.js';
import { getWindowOrigin, toPublicWebUrl } from '#pplx/frontend/common/location.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useCallback, useMemo } from 'react';
export function getPaymentPath({ origin, discountCode, tier, subscriptionTier, redirectPath, closePath, }) {
    const params = new URLSearchParams({ plan: tier, origin });
    if (discountCode) {
        params.set('promotion_code', discountCode);
    }
    if (redirectPath) {
        params.set('redirect_path', redirectPath);
    }
    if (closePath) {
        params.set('close_path', closePath);
    }
    return `/${subscriptionTier ?? 'pro'}/payment?${params.toString()}`;
}
export const useNavigateToPayment = () => {
    const router = useRouter();
    const { track } = useInstrumentation();
    /**
     * Navigates to the checkout page.
     * Returns true if the checkout page was shown, false otherwise.
     */
    const navigateToPayment = useCallback(async ({ origin, discountCode, tier, subscriptionTier = 'pro', redirectPath, closePath, }) => {
        if (!BUILD_CAPABILITIES.payments)
            return false;
        if (shouldOpenSubscriptionOnWeb()) {
            openWebSubscriptionPage(subscriptionTier, `navigate-to-payment:${origin}`);
            return true;
        }
        const paymentPath = getPaymentPath({
            origin,
            discountCode,
            tier,
            subscriptionTier,
            redirectPath,
            closePath,
        });
        const url = new URL(paymentPath, getWindowOrigin({ intent: 'document' }));
        track(proCheckoutStartedEvent({
            name: 'pro checkout started',
            data: {
                subscriptionTier,
                origin,
                discountCode: discountCode ?? '',
                tier,
                flowType: 'embedded_checkout',
            },
        }));
        // In sidecar, open payment page in new tab since routing within
        // the sidecar panel doesn't work correctly.
        if (import.meta.env.VITE_IS_SIDECAR_BUILD || import.meta.env.VITE_IS_EMBEDDED_SIDECAR_BUILD) {
            window.open(toPublicWebUrl(`${url.pathname}${url.search}`), '_blank');
        }
        else {
            router.push(url.toString());
        }
        return true;
    }, [router, track]);
    return useMemo(() => ({
        navigateToPayment,
    }), [navigateToPayment]);
};
import * as BUILD_CAPABILITIES from '#pplx/frontend/deployment-capabilities/build.js';
//# sourceMappingURL=useNavigateToPayment.js.map